import * as React from "react";
import { List, Datagrid, Edit, Create, SimpleForm, TextField, EditButton, TextInput, TranslatableInputs, useTranslate, useLocaleState } from 'react-admin';

// Components
import EmptyList from "../components/misc/EmptyList";

// Entity
const entity = "cities";

export const CityList = (props) => {
    const translate = useTranslate();
    const [locale] = useLocaleState();
    const localeNameKey = locale === 'tr' ? 'name.tr' : 'name.en';

    return (
        <List {...props} title={translate('cities.title', { _: 'Şehirler' })} empty={<EmptyList entity={entity} />} exporter={false}>
            <Datagrid>
                <TextField source={localeNameKey} label={translate('cities.name', { _: 'Şehir Adı' })} />
                <EditButton />
            </Datagrid>
        </List>
    );
};

export const CityEdit = (props) => {
    const translate = useTranslate();
    return (
        <Edit title={translate('cities.edit_city', { _: 'Şehri Düzenle' })} {...props}>
            <SimpleForm redirect={`/${entity}`}>
                <TextInput source="id" label={"ID"} disabled />
                <TranslatableInputs locales={['tr', 'en']}>
                    <TextInput source="name" label={translate('cities.name', { _: 'Şehir Adı' })} fullWidth />
                </TranslatableInputs>
            </SimpleForm>
        </Edit>
    );
};

export const CityCreate = (props) => {
    const translate = useTranslate();
    return (
        <Create title={translate('cities.new_city', { _: 'Yeni Şehir' })} {...props}>
            <SimpleForm redirect={`/${entity}`}>
                <TextInput source="id" label={"ID"} />
                <TranslatableInputs locales={['tr', 'en']}>
                    <TextInput source="name" label={translate('cities.name', { _: 'Şehir Adı' })} fullWidth />
                </TranslatableInputs>
            </SimpleForm>
        </Create>
    );
};
